import * as React from "react";
import { Layout } from "../Layout.web";
import type { HomePageContainerProps } from "./HomeContainer.web.data";
import { HomePage } from "./HomePage.web";

export const HomePageContainer: React.FC<HomePageContainerProps> = ({
  header,
  setting,
  locale,
  serviceHost,
  bannerImageSection,
  videoSection,
  appNavSection,
  promptArtSection,
  privacySection,
  moreSection,
}) => {
  return (
    <Layout
      header={header}
      setting={{ ...setting, showManageAccess: false }}
      data-testid="home-container"
    >
      <HomePage
        header={header}
        locale={locale}
        serviceHost={serviceHost}
        bannerImageSection={bannerImageSection}
        videoSection={videoSection}
        appNavSection={appNavSection}
        promptArtSection={promptArtSection}
        privacySection={privacySection}
        moreSection={moreSection}
      ></HomePage>
    </Layout>
  );
};
